var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"temp-wrapper"},[_c('img',{class:[ _vm.isMobile ? 'responsive' : '' ],attrs:{"alt":"Maintenace","src":require("../assets/underMaintenance.jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }